<template>
    <div class="product-add pb50" v-loading="loading">
        <div>
            <div class="common-form">会员信息</div>
            <div>
                <div style="float: left;width: 380px;">会员昵称：{{userInfo.nickName}}</div>
                <div style="float: left;width: 380px;">会员等级：{{userInfo.name}}</div>
                <div v-if="userInfo.referee_id == 0">上级：无</div>
                <div v-else>上级：{{userInfo.referee_name}}</div>
                <div style="clear:both;"></div>
            </div>
            <div style="margin-top: 20px;">
                <div style="float: left;width: 380px;">签到有效期：{{userInfo.dated_at}}</div>
                <div style="float: left;">累计签到次数：{{userInfo.count}}</div>
                <div style="clear:both;"></div>
            </div>
        </div>
        <div style="margin-top: 100px">
            <div class="common-form">签到记录</div>
            <!--搜索表单-->
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="状态">
                        <el-select v-model="formInline.status" placeholder="签到状态">
                            <el-option label="全部" value="-1"></el-option>
                            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="status_type[index]"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="签到日期">
                        <div class="block">
                            <span class="demonstration"></span>
                            <el-date-picker v-model="formInline.reg_date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
                </el-form>
            </div>
            <!-- 列表 -->
            <div class="table-wrap">
                <el-table :data="tableData" style="width: 100%" v-loading="loading">
                    <el-table-column prop="created_at" label="签到日期" width="360"></el-table-column>
                    <el-table-column prop="created_at" label="签到数据" width="260">
                        <template slot-scope="scope">
                            <div class="text-ellipsis">左眼：{{scope.row.field_number_2}}</div>
                            <div class="text-ellipsis">右眼：{{scope.row.field_number_1}}</div>
                            <div class="text-ellipsis">双眼：{{scope.row.field_number_3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="img" label="签到照片">
                        <template slot-scope="scope">
                            <img v-img-url="scope.row.img[0]" width="80" height="80"  style="float: left"/>
                            <img v-img-url="scope.row.img[1]" width="80" height="80"  style="float: left;margin-left: 20px"/>
                            <img v-img-url="scope.row.img[2]" width="80" height="80"  style="float: left;margin-left: 20px"/>
                            <div style="clear: both"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="120"></el-table-column>
                </el-table>

                <!--分页-->
                <div class="pagination">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            background
                            :current-page="curPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next, jumper"
                            :total="totalDataNumber"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SignadvApi from '@/api/signadv.js';
    export default {
        components: {},
        data() {
            return {
                loading: true,
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                formInline: {},
                /*用户信息 */
                userInfo:{},
                status:['未审核','已审核'],
                status_type:['0','3'],
                /* 表格数据 */
                tableData:[],
            };
        },
        created() {
            /*会员信息*/
            this.getUser();
        },
        methods: {
            /* 获取会员信息 */
            getUser(){
                let self = this;
                // 取到路由带过来的参数
                const Params = {};
                Params.user_id = self.$route.query.user_id
                console.log(Params)
                SignadvApi.getUser(Params,true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.userInfo = data.data.user;
                        self.getList();
                    })
                    .catch(error => {
                        console.log(error)
                        self.loading = false;
                    });
            },
            /* 获取列表信息 */
            getList(){
                let self = this;
                let Params = self.formInline;
                Params.user_id = self.$route.query.user_id
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                console.log(Params)
                SignadvApi.getList(Params,true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch(error => {
                        self.loading = false;
                    });

            },
            /* 查询 */
            onSubmit(){
                let self = this;
                self.loading = true;
                let Params = self.formInline;
                self.getList();
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getList();
            },
            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getList();
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/signadv/archives/detailed.vue